import { render, staticRenderFns } from "./InternalInformationSection.vue?vue&type=template&id=f527732e&scoped=true&"
import script from "./InternalInformationSection.vue?vue&type=script&lang=js&"
export * from "./InternalInformationSection.vue?vue&type=script&lang=js&"
import style0 from "./InternalInformationSection.vue?vue&type=style&index=0&id=f527732e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f527732e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VCol,VRow,VSkeletonLoader,VTextField})
